/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum IriroActionType {
  VIEW_ORDER,
  ADD,
  EDIT,
  DELETE,
  TEMPLATE,
  ACCEPT,
  SELECT_ONE,
  ORDER_COMPLAINT,
  BLACKLIST_HISTORY,
  CREATE_FROM_EXISTING_ORDER,
  RESOLVE_COMPLAINT,
  FILTER_SAVE,
  TERRITORY_CHANGE,
  FAVOURITE_CHANGE,
  ORDER_STATUS_CHANGE,
  RESEND_ORDER_EMAIL,
  RESEND_EMAIL,
  UPDATE_ACCOUNT,
  REFRESH_LIST,
  ARCHIVE_ORDER,
  UNARCHIVE_ORDER,
  CUSTOMER_WALLET_CURRENCY_CODE_CHANGE,
  RESEND_INVOICE_UPLOAD_INVITATION_EMAIL,
  AUDIT,
  VIEW,
  DOWNLOAD_ORDER_AUDIT_PDF,
  DOWNLOAD_INVOICES_PDFS_ZIP
}
